// import type { Components } from '@mui/material/styles';

export default function MUIAlertTitle() /* : Components['MuiAlertTitle'] */ {
  return {
    // defaultProps: {},
    // styleOverrides: {},
    // variants: [],
  };
}
